interface ChessViewNotFoundProps {
  roomId: string;
  info: { found: false; isReserved?: boolean; isOwner?: boolean };
  canCreate: boolean;
  onCreate: () => void;
}

export const ChessViewNotFound = (
  { roomId, info, canCreate, onCreate }: ChessViewNotFoundProps,
) => {
  const isReservedByOther = info.isReserved && !info.isOwner;
  const isMyReservation = info.isReserved && info.isOwner;

  return (
    <div
      key="view-not-found"
      class="flex flex-col items-center justify-center h-screen bg-base-200 p-4 space-y-6"
    >
      <div class="text-center space-y-2">
        <h2 class="text-4xl font-black text-primary tracking-tighter uppercase">
          {isReservedByOther
            ? "Reserved ID"
            : (isMyReservation ? "Your Room" : "Room Not Found")}
        </h2>
        <p class="opacity-60 font-bold italic">
          {isReservedByOther
            ? `The code "${roomId}" is reserved and can only be started by its owner.`
            : (isMyReservation
              ? `You have reserved the code "${roomId}". Ready to play?`
              : `The room code "${roomId}" doesn't exist yet.`)}
        </p>
      </div>
      <div class="card w-full max-w-sm bg-base-100 shadow-2xl overflow-hidden transform hover:scale-105 transition-transform duration-300">
        <div class="card-body items-center text-center space-y-4">
          {!isReservedByOther
            ? (
              <>
                {canCreate || isMyReservation
                  ? (
                    <>
                      <div class="text-xs uppercase font-black opacity-30 tracking-widest">
                        {isMyReservation ? "Start Game" : "Wanna start it?"}
                      </div>
                      <button
                        type="button"
                        class="btn btn-primary btn-lg w-full font-black uppercase text-xl h-20 shadow-xl"
                        onClick={onCreate}
                      >
                        {isMyReservation
                          ? "Start Room"
                          : `Create Room ${roomId}`}
                      </button>
                    </>
                  )
                  : (
                    <>
                      <div class="text-xs uppercase font-black opacity-30 tracking-widest">
                        Login Required
                      </div>
                      <div class="p-4 bg-base-200 rounded-lg w-full">
                        <p class="text-sm opacity-70">
                          You need to be logged in to create custom rooms.
                        </p>
                      </div>
                      <a
                        href="/login"
                        class="btn btn-primary w-full font-black uppercase"
                      >
                        Login
                      </a>
                    </>
                  )}
              </>
            )
            : (
              <>
                <div class="text-xs uppercase font-black opacity-30 tracking-widest">
                  Reserved Room
                </div>
                <div class="p-4 bg-base-200 rounded-lg w-full">
                  <p class="text-sm opacity-70">
                    You can't start this room because it's reserved by someone
                    else.
                  </p>
                </div>
                <a
                  href="/profile"
                  class="btn btn-secondary w-full font-black uppercase"
                >
                  Reserve your own ID
                </a>
              </>
            )}
          <a href="/chess" class="btn btn-ghost btn-sm opacity-50 font-black">
            Back to Lobby
          </a>
        </div>
      </div>
    </div>
  );
};
